import _ from 'lodash';
import * as yup from 'yup';
import { FORM_ERROR } from 'final-form';

export function makeValidationSchema( fields ) {
  return yup.object().shape( _.fromPairs( _.map( fields, field => {
    let val = field.validator || yup.string();
    if ( field.required ) val = val.required( 'Required' );
    return [ field.name, val ];
  } ) ) );
}

export async function validate( fields, validator, values ) {
  if ( _.isPlainObject( validator ) ) {
    values = validator;
    validator = undefined;
  }
  try {
    const schema = makeValidationSchema( fields );
    await schema.validate( values, { abortEarly : false } );
  } catch( err ) {
    return _.fromPairs( _.map( err.inner, inner => (
      _.at( inner, 'path', 'message' )
    ) ) );
  }
  if ( typeof validator === 'function' ) {
    try {
      await validator( values );
    } catch( err ) {
      return formError( err.message );
    }
  }
}

export function formError( message ) {
  return { [ FORM_ERROR ] : message };
}

export { yup };
